export enum ButtonSize {
  SMALL = 'small',
  DEFAULT = 'default',
}

export enum ButtonVariant {
  PRIMARY = 'primary',
  ATTENTION = 'attention'
}